import { global_hooks } from 'src/globals';

function init() {
	gravityforms_interface();
}
init();

function gravityforms_interface() {
	document.addEventListener('gform/post_render', (e) => {
		const form_id = e.detail.formId;
		const page = e.detail.currentPage;
		const el = document.querySelector('#gform_wrapper_' + e.detail.formId);

		global_hooks.do('gform/render', { form_id, page, el });
		global_hooks.do(`gform/render/${form_id}`, { page, el });

		global_hooks.do_queue('gform/render', { form_id, page, el });
		global_hooks.do_queue(`gform/render/${form_id}`, { page, el });

		load_dynamic_components({ form_id, page, el });
	});
}

function load_dynamic_components(args) {
	if (args.el.querySelector('.gfield_select')) {
		import('./dropdown_styling').then((e) => e.init(args));
	}
}
